module.exports = __webpack_public_path__ + "static/media/icon_table.4f72a6de.svg";